<template>
  <div class="apply-add-form">
    <template v-if="fromShow">
      <div class="main-container">
        <div class="common-area">
          <my-form
            ref="formRef"
            :data.sync="data"
            :loading="loading"
            :option="option"
            width="auto"
            :footer-visible="false"
            @submit="handleSubmit"
          />
        </div>
      </div>

      <!-- submit and reset -->
      <b-row>
        <b-col
          cols="12"
          class="my-form_btns"
        >
          <p class="text-secondary">
            {{ explain }}
          </p>
          <b-button
            variant="primary"
            class="mr-3"
            :disabled="loading"
            @click="send"
          >
            {{ $t('_components.btns.send') }}
          </b-button>
          <b-button
            variant="outline-primary"
            :disabled="loading"
            @click="saveDrafts"
          >
            {{ $t('_components.btns.saveDrafts') }}
          </b-button>
        </b-col>
      </b-row>
    </template>
    <component
      :is="flowKey"
      v-else
      :process-key="processKey"
      :explain="explain"
      @cancel="handleCustFormCancel"
      @close="$emit('close')"
    />
  </div>
</template>

<script>
import {
  BRow, BCol, BButton,
} from 'bootstrap-vue'
import MyForm from '@/components/myForm/index.vue';
import applyAPI from '@/api/apply/index'
import templateFormAPI from '@/api/templateForm/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import website from '@/config/website';
import { templateFormat } from '@/util/func'
import { mapGetters } from 'vuex'
// custForm
// import Induction from './custForm/induction.vue'
import Induction from '@/views/apply/components/custForm/induction.vue'
import WORKER from '@/api/worker/index';
import { processOption } from '@/config/processOption'

export default {
  name: 'ApplyAddForm',
  components: {
    MyForm,
    BRow,
    BCol,
    BButton,
    Induction,
  },
  props: {
    formId: {
      type: [Number, String],
      default: undefined,
    },
    processKey: {
      type: String,
      default: undefined,
    },
    explain: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      fromShow: true,
      flowKey: '',
      form: {
        isPass: false,
      },
      isDrafts: false,
      loading: false,
      data: {
        // deptId: null,
        // projectId: 6,
      },
      columns: [],
      hasDept: false,
      staffQueryParams: {
        8: {
          status: 1,
        },
        7: {
          status: 1,
        },
        1: {
          status: 1,
        },
      },
      baseData: [],
    }
  },
  computed: {
    ...mapGetters(['userAllInfo', 'courseList']),
    workerId() {
      return this.userAllInfo.workerId
    },
    companyId() {
      return this.userAllInfo.staffInfo.companyId || this.userAllInfo.workerInfo.companyId
    },
    option() {
      const columns = []
      this.columns.forEach(item => {
        const dictQuery = {}
        const temp = item
        if (item.field === 'startDate') {
          const currentDate = moment().format('YYYY-MM-DD')
          temp.formOption.minDate = currentDate
        }
        if (item.field === 'endDate') {
          const currentDate = moment().format('YYYY-MM-DD')
          temp.formOption.minDate = currentDate
        }

        if (item.field === 'isRenew') {
          if (this.data.course_type) {
            const courseInfo = this.courseList.find(el => el.dictKey === this.data.course_type)
            const isCoretrade = /Coretrade.+/g.test(courseInfo.dictValue)
            if (isCoretrade) {
              temp.formOption.hide = false
            } else {
              temp.formOption.hide = true
              this.data.isRenew = ''
            }
          }
        }

        temp.formOption.dictQuery = dictQuery
        columns.push(temp)
      })
      const option = {
        columns,
      }
      return option
    },
  },
  watch: {
    'data.workerId': {
      handler(e) {
        this.changeCode(e)
      },
    },
  },
  mounted() {
    this.getDetailData()
  },
  methods: {
    async changeCode(workerId) {
      this.loading = true
      const { data } = await WORKER.getWorkBaseDetail({ workerID: workerId })
      const baseData = data.data
      this.data.code = baseData ? baseData.infoVO.employmentCode : ''
      this.onLoad(this.formId)
      this.loading = false
    },
    async getDetailData() {
      // const { data } = await WORKER.getWorkBaseDetail({ workerID: this.workerId })
      // const baseData = data.data
      // this.data.name = baseData.infoVO.name
      // this.data.workerId = this.workerId
      // this.data.code = baseData.infoVO.employmentCode
      // this.data.projectId = String(baseData.infoVO.projectId)
      this.data.applicationDate = moment().format('YYYY-MM-DD')
      this.onLoad(this.formId)
    },
    // i18n
    i18n(param) {
      return this.$t(`_dormitory.${param}`)
    },
    validationForm() {
      console.log(this.form, 'submit')
    },
    resetForm() {
      this.form = {}
    },
    onLoad(formId) {
      templateFormAPI.detail({ formId }).then(res => {
        const temp = res.data.data.records
        this.columns = templateFormat(temp)// , setDictQuery)
      })
    },
    send() {
      this.isDrafts = false
      this.$refs.formRef.validationForm()
    },
    saveDrafts() {
      this.isDrafts = true
      this.$refs.formRef.validationForm()
    },
    arrayToStr(arr) {
      return arr.join(',')
    },
    handleSubmit(form) {
      const params = form
      Object.entries(params).forEach(item => {
        if (item[0] !== 'files') {
          params[item[0]] = Array.isArray(item[1]) ? item[1].join(',') : item[1]
        }
      })
      params.processKey = this.processKey
      params.formId = this.formId
      const router = website.staffProcessRouter
      const findUploads = this.columns.filter(o => o.type === 'upload')
      findUploads.forEach(findUpload => {
        if (Array.isArray(params[findUpload.field])) {
          let key = findUpload.field
          if (findUpload.field === 'files') {
            key = 'fileIds'
          }
          params[key] = params[findUpload.field].map(o => o.attachId).join()
        }
        if (findUpload.field === 'files') {
          delete params[findUpload.field]
        }
      })

      if (this.isDrafts) {
        applyAPI.workerSaveAndStart(params).then(res => {
          this.$emit('close')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        })
      } else {
        // const option = processOption[this.processId]
        const option = processOption[this.formId]
        applyAPI.workerAdd(params, { option: JSON.stringify(option) }).then(res => {
          this.$emit('close')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t('_default.toast.title'),
              icon: 'BellIcon',
              text: this.$t('_default.toast.text.success'),
              variant: 'success',
            },
          })
        })
      }
    },
    handleCustFormCancel() {
      this.flowKey = ''
      this.fromShow = true
      this.onLoad(this.formId)
    },
  },
}

</script>

<style lang='scss' scoped>
.apply-add-form{
    height: 100%;
    position: relative;
    // overflow-y: scroll;
    // height: 1000px;
    .main-container {
      overflow-y: scroll;
      height: 675px;
      .common-area {
        // height: 1300px;
      }
    }
    .my-form{
      height: calc(100% - 100px);
      position: relative;
      overflow: hidden;
      &_btns{
        left: 0;
        right: 0;
        position: absolute;
        bottom: 0;
        text-align: center;
        border-top: 1px solid #EBE9F1;
        background: #FFF;
        padding: 1.5rem 0;
      }
    }
}
</style>
